// extracted by mini-css-extract-plugin
export default {"yj-font-style":"yj-font-style--yJEtX","yj_cp_page_title_wrapper":"yj_cp_page_title_wrapper--UQo9T","yj_cp_page_title":"yj_cp_page_title--Hc5fm"};